import { useMemo } from 'react';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { testWalletsToLowerCase } from '@launchpad/configs/constants/test-wallets';

const testWallets = testWalletsToLowerCase();

const useIsSelfTestUser = () => {
  const { isAuth, userEvmWallet } = useAuth();

  return useMemo(() => {
    if (!isAuth) {
      return false;
    }

    return testWallets.includes(userEvmWallet?.attributes?.address?.toLowerCase() || '');
  }, [isAuth, userEvmWallet?.attributes?.address]);
};

export default useIsSelfTestUser;
